

// import React, { useState, useEffect, useRef } from "react";
// import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube, FaBars, FaTimes } from "react-icons/fa";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import logo from "../pages/modules/Component/maamaaslog.png";
// import NotificationsIcon from "@mui/icons-material/Notifications";
// import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
// import AccountCircleIcon from "@mui/icons-material/AccountCircle";
// import { Link } from 'react-router-dom';
// import SliderComponent from '../pages/modules/Cloudkitchen/SliderComponent.js';
// import { Paper, MenuItem, Slide, IconButton } from "@mui/material";
// import LogoutIcon from "@mui/icons-material/Logout";
// import PersonIcon from "@mui/icons-material/Person";
// import { FaMapMarkerAlt } from "react-icons/fa";
// import { FaSearch } from "react-icons/fa";

// export default function ProfissionalNavbar({ showLogin, setShowLogin }) {
//     const [index, setIndex] = useState(0);
//     const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
//     const [scrolled, setScrolled] = useState(false);
//     const [showMobileMenu, setShowMobileMenu] = useState(false);
//     const [showPopup, setShowPopup] = useState(false);
//     const [showForgetPassword, setShowForgetPassword] = useState(false);
//     const [isForgot, setIsForgot] = useState(false);
//     const [loginObj, setLoginObj] = useState({
//         userName: "",
//         password: "",
//     });
//     const [showPassword, setShowPassword] = useState(false);
//     const [hidePassword, setHidePassword] = useState(true);
//     const [isLoading, setIsLoading] = useState(false);
//     const [error, setError] = useState("");
//     const navigate = useNavigate();
//     const [showPasswordFields, setShowPasswordFields] = useState(false);
//     const [forgotEmail, setForgotEmail] = useState("");
//     const [email, setEmail] = useState("");
//     const [message, setMessage] = useState("");
//     const [isSignup, setIsSignup] = useState(false);
//     const [isEmailSubmitted, setIsEmailSubmitted] = useState(false);
//     const [loginStepStarted, setLoginStepStarted] = useState(false);
//     const [emailCheckMessage, setEmailCheckMessage] = useState("");
//     const [loading, setLoading] = useState(false);
//     const [cartCount, setCartCount] = useState(0);
//     const [signupType, setSignupType] = useState("personal");
//     const [termsAccepted, setTermsAccepted] = useState(false);
//     const [showContainer, setShowContainer] = useState(false);
//     const [drawerOpen, setDrawerOpen] = useState(false);
//     const [isLoginOpen, setIsLoginOpen] = useState(false);
//     const GOOGLE_API_KEY = "";
//     const [userLocation, setUserLocation] = useState("");

//     const [savedAddresses, setSavedAddresses] = useState(() => {
//         const data = localStorage.getItem("savedAddresses");
//         return data ? JSON.parse(data) : [];
//     });

//     // Location states
//     const [showLocationPopup, setShowLocationPopup] = useState(false);
//     const [selectedAddress, setSelectedAddress] = useState(null);

//     const [searchQuery, setSearchQuery] = useState("");
//     const [isLocating, setIsLocating] = useState(false);
//     const [locationError, setLocationError] = useState("");
//     const [showMapPopup, setShowMapPopup] = useState(false);
//     const [mapSelectedLocation, setMapSelectedLocation] = useState(null);
//     const [mapAddress, setMapAddress] = useState("");
//     const [addressTitle, setAddressTitle] = useState("");
//     const [isMapLoading, setIsMapLoading] = useState(false);
//     const [showMobileSearch, setShowMobileSearch] = useState(false);
//     const mapRef = useRef(null);

//     const openLoginDrawer = () => setIsLoginOpen(true);
//     const closeLoginDrawer = () => setIsLoginOpen(false);

//     const userId = localStorage.getItem("userId");

//     const SAVED_KEY = `savedAddresses_${userId}`;
//     const CURRENT_KEY = `currentLocation_${userId}`;
//     const SELECTED_KEY = `selectedAddress_${userId}`;
// const [verificationStatus, setVerificationStatus] = useState(null);
// const [loadingStatus, setLoadingStatus] = useState(true);

// useEffect(() => {
//     const professionalUserId = localStorage.getItem("professionalUserId");
//     const token = localStorage.getItem("authToken");

//     if (!professionalUserId || !token) {
//         setVerificationStatus(null);
//         setLoadingStatus(false);
//         alert("User ID or Token missing");
//         return;
//     }

//     const fetchVerificationStatus = async () => {
//         try {
//             const response = await fetch(
//                 `https://backend.maamaas.com/subscription/api/user/company/verification/${professionalUserId}`,
//                 {
//                     method: "GET",
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                         "Content-Type": "application/json",
//                     },
//                 }
//             );

//             if (!response.ok) {
//                 setVerificationStatus(null);
//                 alert("Failed to fetch verification status");
//                 return;
//             }

//             const data = await response.json();

//             setVerificationStatus(data.verificationStatus);

//             // ✅ ALERT
       

//         } catch (error) {
//             // console.error("❌ Error fetching verification status:", error);
//             alert("Something went wrong while fetching status");
//             setVerificationStatus(null);
//         } finally {
//             setLoadingStatus(false);
//         }
//     };

//     fetchVerificationStatus();
// }, []);


//     useEffect(() => {
//         if (isSignup) {
//             setIsSignup(true);
//             setShowLogin(true);
//         }
//     }, [isSignup]);

//     // Add these useEffect hooks near your other useEffect hooks
//     useEffect(() => {
//         let timeoutId;
//         if (showContainer) {
//             // Auto close after 4 seconds
//             timeoutId = setTimeout(() => {
//                 setShowContainer(false);
//             }, 4000);
//         }

//         return () => {
//             if (timeoutId) clearTimeout(timeoutId);
//         };
//     }, [showContainer]);

//     useEffect(() => {
//         const handleClickOutside = (event) => {
//             // Check if click is outside the profile dropdown and profile icon
//             const profileIcon = document.querySelector('[data-profile-icon]');
//             const dropdown = document.querySelector('[data-profile-dropdown]');

//             if (showContainer &&
//                 profileIcon &&
//                 dropdown &&
//                 !profileIcon.contains(event.target) &&
//                 !dropdown.contains(event.target)) {
//                 setShowContainer(false);
//             }
//         };

//         document.addEventListener('mousedown', handleClickOutside);
//         return () => document.removeEventListener('mousedown', handleClickOutside);
//     }, [showContainer]);

//     function handleSignInClick() {
//         setShowLogin(true);
//     }

//     // Function for profile handling
//     const handleProfile = () => {
//         //console.log("Profile button clicked");
//         setShowContainer(false);

//         setTimeout(() => {
//             navigate("/Profesanlprofile");
//         }, 0);
//     };



//     const handleLogout = () => {
//         // 🔹 Clear session
//         localStorage.removeItem("isLoggedIn");
//         localStorage.removeItem("authToken");
//         localStorage.removeItem("vendorId");
//         localStorage.removeItem("professionalUserId");
//         localStorage.removeItem("userId");

//         // 🔹 Update state
//         setIsLoggedIn(false);
//         setShowContainer(false);

//         // 🔥 Navigate + reload
//         navigate("/", { replace: true });
//         window.location.reload();
//     };

//     useEffect(() => {
//         const token = localStorage.getItem("userToken");
//         if (token) {
//             setIsLoggedIn(true);
//         }
//     }, []);

//     useEffect(() => {
//         const handleResize = () => {
//             setIsMobile(window.innerWidth <= 768);
//             if (window.innerWidth > 768) {
//                 setShowMobileMenu(false);
//             }
//         };

//         const handleScroll = () => setScrolled(window.scrollY > 50);

//         window.addEventListener("resize", handleResize);
//         window.addEventListener("scroll", handleScroll);

//         return () => {
//             window.removeEventListener("resize", handleResize);
//             window.removeEventListener("scroll", handleScroll);
//         };
//     }, []);

//     const handleChange = (e) => {
//         setLoginObj({ ...loginObj, [e.target.name]: e.target.value });
//     };

//     const handleSignup = async (e) => {
//         e.preventDefault();
//         setError("");

//         if (!termsAccepted) {
//             setError("Please select Terms and Conditions");
//             return;
//         }

//         if (!loginObj.userName || !loginObj.emailId || !loginObj.password) {
//             setError("Please fill all required fields");
//             return;
//         }

//         setIsLoading(true);

//         const userType = signupType === "personal" ? "PERSONAL" : "PROFESSIONAL";

//         const requestBody = {
//             userName: loginObj.userName,
//             emailId: loginObj.emailId,
//             password: loginObj.password,
//             referralCodeUsed: loginObj.referralCodeUsed || null,
//             mobileNumber: loginObj.mobileNumber,
//             companyName: loginObj.companyName || null,
//             role: "ROLE_USER",
//             userType: userType,
//             termsAndConditions: termsAccepted,
//         };

//         //console.log("📌 Signup Request Body:", requestBody);

//         const apiUrl =
//             "https://backend.maamaas.com/subscription/api/user/registration";

//         try {
//             const response = await fetch(apiUrl, {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify(requestBody),
//             });

//             //console.log("📌 Response Status:", response.status);

//             let resultText = await response.text();
//             let result;
//             try {
//                 result = JSON.parse(resultText);
//             } catch {
//                 result = { message: resultText };
//             }

//             //console.log("📌 Response Body:", result);

//             if (response.ok) {
//                 alert("Signup successful!");
//                 setIsSignup(false);
//                 setIsForgot(false);
//             } else {
//                 setError(result.message || "Signup failed");
//             }
//         } catch (error) {
//             // console.error("❌ Error during signup:", error);
//             setError("Something went wrong. Please try again.");
//         }

//         setIsLoading(false);
//     };

//     const handleChanges = (e) => {
//         const { name, value } = e.target;
//         setLoginObj((prev) => ({
//             ...prev,
//             [name]: value,
//         }));
//     };

//     // State
//     const [isLoggedIn, setIsLoggedIn] = useState(false);
//     useEffect(() => {
//         const loggedIn = localStorage.getItem("isLoggedIn") === "true";
//         setIsLoggedIn(loggedIn);
//     }, []);

//     const handleLogin = async (e) => {
//         e.preventDefault();
//         setIsLoading(true);
//         setError("");

//         try {
//             // ✅ Create URL with query parameters
//             const url = `https://backend.maamaas.com/subscription/api/auth/login/user?identifier=${encodeURIComponent(
//                 loginObj.identifier
//             )}&password=${encodeURIComponent(loginObj.password)}`;

//             const response = await fetch(url, {
//                 method: "POST",
//                 headers: {
//                     accept: "*/*",
//                 },
//             });

//             // ✅ Try to parse JSON safely
//             const text = await response.text();
//             let data;
//             try {
//                 data = JSON.parse(text);
//             } catch {
//                 // console.error("❌ Server did not return JSON:", text);
//                 throw new Error("Invalid JSON response from server");
//             }

//             //console.log("🔹 Login API Response:", data);

//             if (response.ok && data.token) {
//                 // ✅ Store both tokens and user details
//                 localStorage.setItem("authToken", data.token);
//                 localStorage.setItem("refreshToken", data.refreshToken);
//                 localStorage.setItem("userId", data.userId);
//                 localStorage.setItem("userType", data.userType || "");
//                 localStorage.setItem("professionalUserId", data.professionalUserId);
//                 localStorage.setItem("role", data.role);
//                 localStorage.setItem("isLoggedIn", "true");

//                 alert("Login successful!");
//                 setIsLoggedIn(true);
//                 setShowLogin(false);
//                 navigate("/Digitalfoodall");
//                 const redirectTo =
//                     localStorage.getItem("redirectAfterLogin") || "/Digitalfoodall";

//                 localStorage.removeItem("redirectAfterLogin");

//                 navigate(redirectTo);
//             } else {
//                 setError(data.message || "Invalid credentials. Please check your email or password.");
//             }

//         } catch (error) {
//             // console.error("❌ Login error:", error);
//             setError("Email or Password wrong. Please try again later.");
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     // In your top-level component (Navbar, Header, etc.)
//     useEffect(() => {
//         const checkLogin = () => {
//             const loggedIn = localStorage.getItem("isLoggedIn") === "true";
//             setIsLoggedIn(loggedIn);
//         };

//         checkLogin(); // run on mount

//         window.addEventListener("storage", checkLogin); // sync across tabs/components

//         return () => {
//             window.removeEventListener("storage", checkLogin);
//         };
//     }, []);

//     const togglePopup = () => {
//         setShowPopup(!showPopup);
//     };

//     const toggleMobileMenu = () => {
//         setShowMobileMenu(!showMobileMenu);
//     };

//     const toggleMobileSearch = () => {
//         setShowMobileSearch(!showMobileSearch);
//         setShowMobileMenu(false);
//     };

//     const getColoredText = (text) => {
//         const words = text.split(" ");
//         const half = Math.ceil(words.length / 2);
//         return (
//             <>
//                 <span style={{ color: "#FFD700" }}>{words.slice(0, half).join(" ")} </span>
//                 <span style={{ color: "white" }}>{words.slice(half).join(" ")}</span>
//             </>
//         );
//     };

//     // Initialize Map when popup opens
//     useEffect(() => {
//         if (showMapPopup) {
//             // Load Leaflet CSS if not already loaded
//             if (!document.querySelector('link[href*="leaflet"]')) {
//                 const link = document.createElement('link');
//                 link.rel = 'stylesheet';
//                 link.href = 'https://unpkg.com/leaflet@1.7.1/dist/leaflet.css';
//                 document.head.appendChild(link);
//             }

//             // Load Leaflet JS if not already loaded
//             if (!window.L) {
//                 const script = document.createElement('script');
//                 script.src = 'https://unpkg.com/leaflet@1.7.1/dist/leaflet.js';
//                 script.onload = initializeMap;
//                 document.head.appendChild(script);
//             } else {
//                 initializeMap();
//             }
//         }
//     }, [showMapPopup]);

//     const initializeMap = () => {
//         if (!mapRef.current || !window.L) return;

//         // Clear any existing map
//         if (window.currentMap) {
//             window.currentMap.remove();
//         }

//         const defaultLocation = [40.7128, -74.0060]; // New York

//         const map = window.L.map(mapRef.current).setView(defaultLocation, 13);
//         window.currentMap = map;

//         // Add tile layer
//         window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
//             attribution: '© OpenStreetMap contributors'
//         }).addTo(map);

//         // Add click event to map
//         map.on('click', (e) => {
//             const clickedLocation = [e.latlng.lat, e.latlng.lng];
//             setMapSelectedLocation(clickedLocation);
//             updateMarker(clickedLocation, map);
//             getAddressFromCoordinates(clickedLocation);
//         });

//         // Try to get current location
//         if (navigator.geolocation) {
//             navigator.geolocation.getCurrentPosition(
//                 (position) => {
//                     const userLocation = [position.coords.latitude, position.coords.longitude];
//                     map.setView(userLocation, 15);
//                     setMapSelectedLocation(userLocation);
//                     updateMarker(userLocation, map);
//                     getAddressFromCoordinates(userLocation);
//                 },
//                 () => {
//                     // Use default location if geolocation fails
//                     setMapSelectedLocation(defaultLocation);
//                     updateMarker(defaultLocation, map);
//                     getAddressFromCoordinates(defaultLocation);
//                 }
//             );
//         }
//     };

//     const updateMarker = (location, map) => {
//         // Remove existing marker
//         if (window.currentMarker) {
//             window.currentMarker.remove();
//         }

//         // Add new marker
//         const marker = window.L.marker(location, { draggable: true }).addTo(map);
//         window.currentMarker = marker;

//         // Add dragend event
//         marker.on('dragend', (e) => {
//             const draggedLocation = [e.target.getLatLng().lat, e.target.getLatLng().lng];
//             setMapSelectedLocation(draggedLocation);
//             getAddressFromCoordinates(draggedLocation);
//         });
//     };

//     const getAddressFromCoordinates = async (location) => {
//         setIsMapLoading(true);
//         try {
//             const response = await fetch(
//                 `https://maps.googleapis.com/maps/api/geocode/json?latlng=${location[0]},${location[1]}&key=`
//             );
//             const data = await response.json();

//             if (data.status === "OK" && data.results.length > 0) {
//                 setMapAddress(data.results[0].formatted_address);
//             } else {
//                 setMapAddress("Address not found");
//             }
//         } catch (error) {
//             // console.error("Error getting address:", error);
//             setMapAddress("Error getting address");
//         } finally {
//             setIsMapLoading(false);
//         }
//     };

//     useEffect(() => {
//         localStorage.setItem("savedAddresses", JSON.stringify(savedAddresses));
//     }, [savedAddresses]);

//     useEffect(() => {
//         if (selectedAddress) {
//             localStorage.setItem("selectedAddress", selectedAddress);
//         }
//     }, [selectedAddress]);

//     useEffect(() => {
//         if (!userId) return;
//         localStorage.setItem(SAVED_KEY, JSON.stringify(savedAddresses));
//     }, [savedAddresses, userId]);

//     useEffect(() => {
//         if (!userId || !selectedAddress) return;
//         localStorage.setItem(SELECTED_KEY, selectedAddress);
//     }, [selectedAddress, userId]);

//     useEffect(() => {
//         if (!userId) return;

//         const saved = localStorage.getItem(SAVED_KEY);
//         const current = localStorage.getItem(CURRENT_KEY);

//         if (saved) setSavedAddresses(JSON.parse(saved));

//         if (current) {
//             const c = JSON.parse(current);
//             setSelectedAddress(c.full);
//             setUserLocation({ lat: c.lat, lng: c.lng });
//         }
//     }, [userId]);

//     const handleSaveAddressFromMap = async () => {
//         if (!mapSelectedLocation || !mapAddress) return;

//         const newAddress = {
//             title: addressTitle || "Custom Location",
//             full: mapAddress,
//             lat: mapSelectedLocation[0],
//             lng: mapSelectedLocation[1],
//         };

//         setSavedAddresses(prev => [newAddress, ...prev]);
//         setSelectedAddress(mapAddress);

//         // backend update (per user)
//         const token = localStorage.getItem("authToken");
//         if (token && userId) {
//             await fetch(
//                 "https://backend.maamaas.com/subscription/api/user/curret/location/update",
//                 {
//                     method: "POST",
//                     headers: {
//                         "Content-Type": "application/json",
//                         Authorization: `Bearer ${token}`,
//                     },
//                     body: JSON.stringify({
//                         userId,
//                         latitude: newAddress.lat,
//                         longitude: newAddress.lng,
//                         address: newAddress.full,
//                     }),
//                 }
//             );
//         }

//         setShowMapPopup(false);
//         setShowLocationPopup(false);
//     };

//     useEffect(() => {
//         console.log("Stored current location:",
//             JSON.parse(localStorage.getItem(CURRENT_KEY))
//         );
//     }, []);

//     // 🚀 Save & Load Locations from LocalStorage
//     useEffect(() => {
//         const storedCurrent = localStorage.getItem("currentLocation");
//         const saved = localStorage.getItem("savedAddresses");

//         if (storedCurrent) {
//             const c = JSON.parse(storedCurrent);
//             setSelectedAddress(c.full);
//             setUserLocation({ lat: c.lat, lng: c.lng });
//         }

//         if (saved) {
//             setSavedAddresses(JSON.parse(saved));
//         }
//     }, []);

//     // Function to get current location with detailed address
//     const getCurrentLocation = () => {
//         if (!navigator.geolocation) {
//             setLocationError("Geolocation not supported");
//             return;
//         }

//         setIsLocating(true);
//         setLocationError("");

//         navigator.geolocation.getCurrentPosition(
//             async (pos) => {
//                 const latitude = pos?.coords?.latitude;
//                 const longitude = pos?.coords?.longitude;

//                 if (latitude == null || longitude == null) {
//                     setLocationError("Unable to fetch latitude / longitude");
//                     setIsLocating(false);
//                     return;
//                 }

//                 let fullAddress = `Lat: ${latitude}, Lng: ${longitude}`;

//                 try {
//                     if (GOOGLE_API_KEY) {
//                         const res = await fetch(
//                             `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${GOOGLE_API_KEY}`
//                         );
//                         const data = await res.json();
//                         fullAddress = data?.results?.[0]?.formatted_address || fullAddress;
//                     }
//                 } catch (err) {
//                     // console.error("Geocode error:", err);
//                 }

//                 const currentLocation = {
//                     title: "Current Location",
//                     full: fullAddress,
//                     lat: latitude,
//                     lng: longitude,
//                 };

//                 // ✅ state
//                 setSelectedAddress(fullAddress);
//                 setUserLocation({ lat: latitude, lng: longitude });

//                 // ✅ localStorage
//                 localStorage.setItem(CURRENT_KEY, JSON.stringify(currentLocation));

//                 setSavedAddresses((prev) => {
//                     const exists = prev.some((a) => a.title === "Current Location");
//                     return exists ? prev : [currentLocation, ...prev];
//                 });

//                 setIsLocating(false);
//                 setShowLocationPopup(false);
//             },
//             (error) => {
//                 // console.error("Geolocation error:", error);

//                 let msg = "Location access denied";
//                 if (error.code === 2) msg = "Location unavailable";
//                 if (error.code === 3) msg = "Location request timeout";

//                 setLocationError(msg);
//                 setIsLocating(false);
//             },
//             {
//                 enableHighAccuracy: true,
//                 timeout: 15000,
//                 maximumAge: 0,
//             }
//         );
//     };

//     // Function to search for addresses
//     const handleAddressSearch = async () => {
//         if (!searchQuery.trim()) return;

//         try {
//             const response = await fetch(
//                 `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(searchQuery)}&limit=5`
//             );

//             const data = await response.json();

//             if (data && data.length > 0) {
//                 const result = data[0];
//                 const address = result.display_name;

//                 setSelectedAddress(address);

//                 setSavedAddresses(prev => [
//                     {
//                         title: "Searched Location",
//                         full: address,
//                         lat: parseFloat(result.lat),
//                         lng: parseFloat(result.lon)
//                     },
//                     ...prev
//                 ]);

//                 setShowLocationPopup(false);
//                 setSearchQuery("");
//             } else {
//                 setLocationError("No addresses found for your search.");
//             }
//         } catch (error) {
//             // console.error("Error searching address:", error);
//             setLocationError("Error searching for address. Please try again.");
//         }
//     };

//     useEffect(() => {
//         const handleScroll = () => {
//             setScrolled(window.scrollY > 50);
//         };

//         const handleResize = () => {
//             setIsMobile(window.innerWidth < 768);
//         };

//         window.addEventListener("scroll", handleScroll);
//         window.addEventListener("resize", handleResize);
//         return () => {
//             window.removeEventListener("scroll", handleScroll);
//             window.removeEventListener("resize", handleResize);
//         };
//     }, []);

//     useEffect(() => {
//         const handleScroll = () => {
//             // if page scrolled more than 50px, set true
//             if (window.scrollY > 50) {
//                 setScrolled(true);
//             } else {
//                 setScrolled(false);
//             }
//         };

//         window.addEventListener("scroll", handleScroll);

//         return () => window.removeEventListener("scroll", handleScroll);
//     }, []);

//     const handleEmailChange = (e) => { setEmail(e.target.value); };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true);
//         setMessage("");

//         if (!email) {
//             setMessage("Please enter your email.");
//             setLoading(false);
//             return;
//         }

//         try {
//             const response = await axios.post(
//                 "https://backend.maamaas.com/subscription/api/user/forget/password",
//                 { identifier: email }
//             );

//             if (response.status === 200) {
//                 setMessage("Reset link sent successfully to your email.");
//                 setIsEmailSubmitted(true);
//                 if (error.response?.data?.message?.includes("already") ||
//                     error.response?.data?.message?.includes("again")) {
//                     setMessage("Reset link already sent. Please check your email inbox.");
//                     return;
//                 }

//             } else {
//                 setMessage("Something went wrong. Please try again.");
//             }
//         } catch (error) {
//             console.log("API ERROR:", error);
//             setMessage(
//                 error.response?.data?.message ||
//                 "Error while sending reset link. Please try again."
//             );
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Responsive styles
//     const styles = {
//         nav: {
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100%",
//             zIndex: 100,
//             padding: isMobile ? "10px 16px" : "16px 32px",
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             backgroundColor: scrolled ? "#ee6521" : "#ee6521",
//             color: "white",
//             backdropFilter: scrolled ? "blur(8px)" : "none",
//             boxShadow: scrolled ? "0 2px 10px rgba(0,0,0,0.1)" : "none",
//             transition: "all 0.4s ease",
//             height: "65px",
//         },
//         logo: {
//             display: "flex",
//             alignItems: "center",
//             fontSize: isMobile ? "20px" : "26px",
//             fontWeight: "bold",
//             color: "white",
//             zIndex: 101,
//         },
//         logoText: {
//             color: "white",
//             fontSize: isMobile ? "16px" : "20px",
//             textTransform: "uppercase",
//         },
//         logoTextOrange: {
//             color: "orange",
//             fontSize: isMobile ? "16px" : "20px",
//             textTransform: "uppercase",
//         },
//         navRight: {
//             display: isMobile ? (showMobileMenu ? "flex" : "none") : "flex",
//             flexDirection: isMobile ? "row" : "row",
//             alignItems: "center",
//             justifyContent: "space-evenly",
//             gap: isMobile ? "15px" : "20px",
//             position: isMobile ? "fixed" : "relative",
//             top: isMobile ? "65px" : "auto",
//             left: 0,
//             right: 0,
//             backgroundColor: isMobile ? "#ffffffff" : "transparent",
//             padding: isMobile ? "10px" : "0",
//             width: isMobile ? "100%" : "auto",
//             boxShadow: isMobile ? "0 5px 10px rgba(0,0,0,0.1)" : "none",
//             zIndex: 100,
//             borderRadius: "10px"
//         },
//         link: {
//             textDecoration: "none",
//             color: isMobile ? "#000000ff" : "white",
//             fontSize: isMobile ? "17px" : "18px",
//             fontWeight: "bold",
//             cursor: "pointer",
//             whiteSpace: "nowrap",
//             padding: isMobile ? "8px 0" : "0",
//             textTransform: "uppercase",
//         },
//         navLinks: {
//             display: "flex",
//             flexDirection: isMobile ? "row" : "row",
//             alignItems: "center",
//             gap: isMobile ? "5px" : "20px",
//             marginRight: isMobile ? "0" : "20px",
//         },
//         iconWrapper: {
//             borderRadius: "50%",
//             padding: "8px",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             width: "36px",
//             height: "36px",
//             cursor: "pointer",
//         },
//         signInBtn: {
//             padding: isMobile ? "8px 16px" : "10px 20px",
//             backgroundColor: "orange",
//             border: "none",
//             borderRadius: "15px",
//             color: "white",
//             fontWeight: "600",
//             cursor: "pointer",
//             fontSize: isMobile ? "14px" : "16px",
//             whiteSpace: "nowrap",
//             textTransform: "uppercase",
//         },
//         mobileMenuButton: {
//             display: isMobile ? "block" : "none",
//             background: "none",
//             border: "none",
//             color: "white",
//             fontSize: "24px",
//             cursor: "pointer",
//             zIndex: 102,
//         },
//         loginForm: {
//             position: "fixed",
//             top: isMobile ? "10px" : "20px",
//             right: showLogin ? "0" : "-100%",
//             width: "100%",
//             maxWidth: isMobile ? "90%" : "400px",
//             height: isMobile ? "90vh" : "70vh",
//             backgroundColor: "white",
//             borderRadius: "20px",
//             padding: isMobile ? "20px 15px" : "40px 30px",
//             boxShadow: "-5px 0 15px rgba(0, 0, 0, 0.1)",
//             transition: "right 0.5s ease-in-out",
//             zIndex: 999,
//             display: "flex",
//             flexDirection: "column",
//             gap: "20px",
//             overflowY: "auto",
//         },
//         mobileSearchButton: {
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             padding: "8px",
//             backgroundColor: "rgba(255, 255, 255, 0.15)",
//             borderRadius: "50%",
//             border: "none",
//             color: "white",
//             cursor: "pointer",
//             transition: "all 0.3s ease",
//         },
//         // Location Popup Styles
//         locationPopupOverlay: {
//             position: "fixed",
//             top: 59,
//             left: 0,
//             width: "100%",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             zIndex: 1000,
//             padding: isMobile ? "10px" : "20px",
//             boxSizing: "border-box",
//         },
//         locationPopup: {
//             width: "100%",
//             maxWidth: "500px",
//             maxHeight: "80vh",
//             backgroundColor: "white",
//             borderRadius: "12px",
//             padding: "20px",
//             boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
//             overflowY: "auto",
//             position: "relative",
//         },
//         popupHeader: {
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             marginBottom: "20px",
//             paddingBottom: "15px",
//             borderBottom: "1px solid #eee",
//         },
//         popupTitle: {
//             margin: 0,
//             fontSize: "20px",
//             fontWeight: "600",
//             color: "#333",
//         },
//         closePopupBtn: {
//             background: "transparent",
//             border: "none",
//             fontSize: "20px",
//             cursor: "pointer",
//             color: "#666",
//             padding: "5px",
//         },
//         searchContainer: {
//             display: "flex",
//             alignItems: "center",
//             marginBottom: "20px",
//             position: "relative",
//         },
//         searchIcon: {
//             position: "absolute",
//             left: "12px",
//             fontSize: "16px",
//             color: "#666",
//             zIndex: 1,
//         },
//         popupSearchInput: {
//             width: "100%",
//             padding: "12px 12px 12px 40px",
//             borderRadius: "8px",
//             border: "1px solid #ddd",
//             fontSize: "14px",
//             outline: "none",
//             transition: "border 0.3s ease",
//         },
//         optionBox: {
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             padding: "15px",
//             backgroundColor: "#f8f9fa",
//             borderRadius: "8px",
//             marginBottom: "15px",
//             cursor: "pointer",
//             transition: "all 0.3s ease",
//             border: "1px solid #e9ecef",
//         },
//         optionContent: {
//             display: "flex",
//             alignItems: "center",
//             gap: "12px",
//         },
//         optionTitle: {
//             margin: 0,
//             fontSize: "16px",
//             fontWeight: "600",
//             color: "#333",
//         },
//         optionDesc: {
//             margin: "4px 0 0 0",
//             fontSize: "13px",
//             color: "#666",
//         },
//         enableBtn: {
//             padding: "8px 16px",
//             backgroundColor: "#9d36caff",
//             color: "white",
//             border: "none",
//             borderRadius: "6px",
//             fontSize: "13px",
//             fontWeight: "500",
//             cursor: "pointer",
//             transition: "background 0.3s ease",
//             display: "flex",
//             alignItems: "center",
//             gap: "6px",
//         },
//         addAddressBox: {
//             display: "flex",
//             alignItems: "center",
//             gap: "12px",
//             padding: "15px",
//             backgroundColor: "#f0f8ff",
//             borderRadius: "8px",
//             marginBottom: "20px",
//             cursor: "pointer",
//             transition: "all 0.3s ease",
//             border: "1px dashed #a54dd4ff",
//         },
//         plusIcon: {
//             fontSize: "18px",
//             color: "#a551d9ff",
//             fontWeight: "bold",
//         },
//         addAddressText: {
//             fontSize: "16px",
//             fontWeight: "500",
//             color: "#983fc1ff",
//         },
//         errorMessage: {
//             padding: "10px 15px",
//             backgroundColor: "#ffe6e6",
//             color: "#d63031",
//             borderRadius: "6px",
//             marginBottom: "15px",
//             fontSize: "14px",
//         },
//         savedHeading: {
//             fontSize: "16px",
//             fontWeight: "600",
//             color: "#333",
//             marginBottom: "12px",
//         },
//         savedBox: {
//             display: "flex",
//             alignItems: "flex-start",
//             gap: "12px",
//             padding: "15px",
//             backgroundColor: "#fff",
//             borderRadius: "8px",
//             marginBottom: "10px",
//             cursor: "pointer",
//             transition: "all 0.3s ease",
//             border: "1px solid #eee",
//         },
//         savedLeft: {
//             display: "flex",
//             alignItems: "center",
//             gap: "8px",
//         },
//         pinIcon: {
//             color: "#d63031",
//             fontSize: "16px",
//         },
//         savedTitle: {
//             margin: 0,
//             fontSize: "15px",
//             fontWeight: "600",
//             color: "#333",
//         },
//         savedAddressText: {
//             margin: "4px 0 0 0",
//             fontSize: "13px",
//             color: "#666",
//             lineHeight: "1.4",
//         },
//         loadingSpinner: {
//             display: "inline-block",
//             width: "12px",
//             height: "12px",
//             border: "2px solid transparent",
//             borderTop: "2px solid currentColor",
//             borderRadius: "50%",
//             animation: "spin 1s linear infinite",
//         },
//         // Mobile Search Styles
//         mobileSearchContainer: {
//             display: isMobile && showMobileSearch ? "flex" : "none",
//             position: "fixed",
//             top: "65px",
//             left: 0,
//             right: 0,
//             backgroundColor: "white",
//             padding: "15px",
//             boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
//             zIndex: 99,
//             alignItems: "center",
//             gap: "10px",
//         },
//         mobileSearchInput: {
//             flex: 1,
//             padding: "12px 15px",
//             borderRadius: "25px",
//             border: "1px solid #ddd",
//             outline: "none",
//             fontSize: "14px",
//             backgroundColor: "#f8f9fa",
//         },
//         mobileSearchClose: {
//             background: "transparent",
//             border: "none",
//             fontSize: "20px",
//             cursor: "pointer",
//             color: "#666",
//         },
//     };

//     return (
//         <>
//             {/* Navbar */}
//             <nav style={styles.nav}>
//                 <div style={styles.logo}>
//                     <Link
//                         to="/"
//                         style={{
//                             ...styles.logo,
//                             textDecoration: "none",
//                         }}
//                     >
//                         <div
//                             style={{
//                                 fontSize: window.innerWidth <= 600 ? "20px" : "32px", // mobile में छोटा
//                                 fontWeight: "bold",
//                                 fontFamily: "'Poppins', sans-serif",
//                                 display: "inline-block",
//                                 margin: 0,
//                             }}
//                         >
//                             <span style={{ color: "white" }}>MAA</span>
//                             <span style={{ color: "white" }}>MAAS</span>
//                         </div>
//                     </Link>
//                 </div>

//                 {isMobile && (
//                     <div
//                         style={{
//                             border: "2px solid white",
//                             padding: "6px 16px",
//                             display: "flex",
//                             borderRadius: "25px",
//                             alignItems: "center",
//                             cursor: "pointer",
//                             transition: "all 0.3s ease",
//                             color: "white",
//                             backgroundColor: "transparent",
//                         }}
//                         onClick={() => setShowContainer(!showContainer)}
//                     >
//                         <AccountCircleIcon sx={{ fontSize: "22px", color: "white" }} />
//                     </div>
//                 )}

//                 <div style={styles.navRight}>
//                     {/* Only show profile icon */}
//                     <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
//                         {isLoggedIn ? (
//                             <>
//                                 <div
//                                     style={{
//                                         border: isMobile ? "2px solid black" : "2px solid white",
//                                         padding: "6px 16px",
//                                         borderRadius: "25px",
//                                         display: "flex",
//                                         alignItems: "center",
//                                         cursor: "pointer",
//                                         transition: "all 0.3s ease",
//                                         color: isMobile ? "black" : "white",
//                                         backgroundColor: "transparent",
//                                     }}
//                                     onClick={() => setShowContainer(!showContainer)}
//                                     onMouseEnter={(e) => {
//                                         if (!isMobile) {
//                                             // Desktop hover effect
//                                             e.currentTarget.style.backgroundColor = "white";
//                                             e.currentTarget.style.color = "#ff6600";
//                                         }
//                                     }}
//                                     onMouseLeave={(e) => {
//                                         if (!isMobile) {
//                                             // Desktop hover effect ends
//                                             e.currentTarget.style.backgroundColor = "transparent";
//                                             e.currentTarget.style.color = "white";
//                                         }
//                                     }}
//                                 >
//                                     <AccountCircleIcon
//                                         sx={{ fontSize: "22px", color: isMobile ? "black" : "white" }}
//                                     />
//                                 </div>

//                             </>
//                         ) : (
//                             <SliderComponent setShowLogin={setShowLogin} />
//                         )}
//                     </div>
//                 </div>
//             </nav>

//             {/* Login Form Popup */}
//             <div style={styles.loginForm}>
//                 {/* Close Button */}
//                 <button
//                     style={{
//                         position: "absolute",
//                         top: "15px",
//                         right: "20px",
//                         fontSize: "28px",
//                         background: "none",
//                         border: "none",
//                         color: "#333",
//                         cursor: "pointer",
//                     }}
//                     onClick={() => {
//                         setShowLogin(false);
//                         setIsForgot(false);
//                         setIsSignup(false);
//                     }}
//                 >
//                     &times;
//                 </button>

//                 <p
//                     style={{
//                         marginBottom: 0,
//                         fontFamily: "revert",
//                         fontSize: isMobile ? "18px" : "22px",
//                         color: "#6f21b4ff",
//                         fontWeight: "bold",
//                     }}
//                 >
//                     WELCOME TO MAAMAA'S
//                 </p>

//                 {/* Login Form */}
//                 {!isSignup && !isForgot && (
//                     <>
//                         <form
//                             onSubmit={handleLogin}
//                             style={{
//                                 display: "flex",
//                                 flexDirection: "column",
//                                 gap: "10px",
//                             }}
//                         >
//                             <input
//                                 type="text"
//                                 placeholder="User ID"
//                                 name="identifier"
//                                 value={loginObj.identifier}
//                                 onChange={handleChanges}
//                                 style={{
//                                     padding: "10px",
//                                     fontSize: "16px",
//                                     border: "1px solid #ccc",
//                                     borderRadius: "6px",
//                                 }}
//                             />

//                             <div style={{ position: "relative", display: "inline-block", width: "100%" }}>
//                                 <input
//                                     type={showPassword ? "text" : "password"}
//                                     placeholder="Password"
//                                     name="password"
//                                     value={loginObj.password}
//                                     onChange={handleChanges}
//                                     style={{
//                                         padding: "10px",
//                                         paddingRight: "40px",
//                                         fontSize: "16px",
//                                         border: "1px solid #ccc",
//                                         borderRadius: "6px",
//                                         width: "100%",
//                                         boxSizing: "border-box"
//                                     }}
//                                 />
//                                 <span
//                                     onClick={() => setShowPassword(!showPassword)}
//                                     style={{
//                                         position: "absolute",
//                                         top: "50%",
//                                         right: "10px",
//                                         transform: "translateY(-50%)",
//                                         cursor: "pointer",
//                                         color: "#888"
//                                     }}
//                                 >
//                                     {showPassword ? <FaEyeSlash /> : <FaEye />}
//                                 </span>
//                             </div>

//                             <div style={{ textAlign: "right" }}>
//                                 <span
//                                     onClick={() => setIsForgot(true)}   // 🔑 Ye toggle karega forgot form ko
//                                     style={{
//                                         color: "#007bff",
//                                         fontSize: "14px",
//                                         textDecoration: "none",
//                                         cursor: "pointer",
//                                     }}
//                                 >
//                                     Forget Password?
//                                 </span>
//                             </div>
//                             {error && (
//                                 <p style={{ color: "red", marginTop: "10px" }}>{error}</p>
//                             )}
//                             <button
//                                 type="submit"
//                                 style={{
//                                     backgroundColor: "#ee6521",
//                                     color: "white",
//                                     fontWeight: "bold",
//                                     padding: "12px",
//                                     border: "none",
//                                     borderRadius: "6px",
//                                     cursor: "pointer",
//                                 }}
//                                 disabled={isLoading}
//                             >
//                                 {isLoading ? "Logging in..." : "LOGIN"}
//                             </button>
//                         </form>
//                     </>
//                 )}

//                 {/* Forgot Password Form */}
//                 {isForgot && !isEmailSubmitted && (
//                     <form onSubmit={handleSubmit}>
//                         <div>
//                             <input
//                                 type="email"
//                                 id="email"
//                                 name="email"
//                                 placeholder="Enter your email"
//                                 value={email}
//                                 onChange={handleEmailChange}
//                                 required
//                                 style={{
//                                     padding: "10px",
//                                     fontSize: "16px",
//                                     border: "1px solid #ccc",
//                                     borderRadius: "6px",
//                                     marginBottom: "10px",
//                                     width: "100%",
//                                 }}
//                             />
//                         </div>

//                         <button
//                             type="submit"
//                             style={{
//                                 backgroundColor: "#ee6521",
//                                 color: "white",
//                                 fontWeight: "bold",
//                                 padding: "12px",
//                                 border: "none",
//                                 borderRadius: "6px",
//                                 cursor: "pointer",
//                                 width: "100%",
//                             }}
//                             disabled={loading}
//                         >
//                             {loading ? "Sending..." : "Submit"}
//                         </button>

//                         {/* Back to login link */}
//                         <div style={{ marginTop: "10px", textAlign: "center" }}>
//                             <span
//                                 onClick={() => setIsForgot(false)}   // 👈 Ye bilkul sahi hai
//                                 style={{
//                                     color: "#007bff",
//                                     fontSize: "14px",
//                                     cursor: "pointer",
//                                 }}
//                             >
//                                 Back to Login
//                             </span>
//                         </div>

//                         {/* Message section (error / success) */}
//                         {message && (
//                             <p style={{ marginTop: "12px", color: "red", textAlign: "center" }}>
//                                 {message}
//                             </p>
//                         )}
//                     </form>
//                 )}

//                 {/* Success/Error Message */}
//                 {message && (
//                     <div
//                         style={{
//                             marginTop: "15px",
//                             padding: "10px",
//                             borderRadius: "6px",
//                             textAlign: "center",
//                             color: message.includes("successfully") ? "green" : "red",
//                             fontWeight: "bold",
//                         }}
//                     >
//                         {message}
//                     </div>
//                 )}

//                 {/* Signup Form */}
//                 {isSignup && (
//                     <>
//                         {/* Signup Type Selector */}
//                         <div
//                             style={{
//                                 display: "flex",
//                                 gap: "20px",
//                                 justifyContent: "center",
//                                 marginBottom: "10px",
//                             }}
//                         >
//                             <label>
//                                 <input
//                                     type="radio"
//                                     name="signupType"
//                                     value="personal"
//                                     checked={signupType === "personal"}
//                                     onChange={() => setSignupType("personal")}
//                                 />{" "}
//                                 Personal
//                             </label>
//                             <label>
//                                 <input
//                                     type="radio"
//                                     name="signupType"
//                                     value="professional"
//                                     checked={signupType === "professional"}
//                                     onChange={() => setSignupType("professional")}
//                                 />{" "}
//                                 Professional
//                             </label>
//                         </div>

//                         <form
//                             onSubmit={handleSignup}
//                             style={{
//                                 display: "flex",
//                                 flexDirection: "column",
//                                 gap: "10px",
//                             }}
//                         >
//                             <input
//                                 type="text"
//                                 name="userName"
//                                 placeholder="Name"
//                                 value={loginObj.userName}
//                                 onChange={handleChange}
//                                 style={{
//                                     padding: "10px",
//                                     fontSize: "16px",
//                                     border: "1px solid #ccc",
//                                     borderRadius: "6px",
//                                 }}
//                             />
//                             <input
//                                 type="email"
//                                 name="emailId"
//                                 placeholder="Email"
//                                 value={loginObj.emailId}
//                                 onChange={handleChange}
//                                 style={{
//                                     padding: "10px",
//                                     fontSize: "16px",
//                                     border: "1px solid #ccc",
//                                     borderRadius: "6px",
//                                 }}
//                             />
//                             <input
//                                 type="text"
//                                 name="mobileNumber"
//                                 placeholder="Phone Number"
//                                 value={loginObj.mobileNumber}
//                                 onChange={handleChange}
//                                 style={{
//                                     padding: "10px",
//                                     fontSize: "16px",
//                                     border: "1px solid #ccc",
//                                     borderRadius: "6px",
//                                 }}
//                             />

//                             {/* Show companyName only for Professional */}
//                             {signupType === "professional" && (
//                                 <input
//                                     type="text"
//                                     name="companyName"
//                                     placeholder="Company Name"
//                                     value={loginObj.companyName}
//                                     onChange={handleChange}
//                                     style={{
//                                         padding: "10px",
//                                         fontSize: "16px",
//                                         border: "1px solid #ccc",
//                                         borderRadius: "6px",
//                                     }}
//                                 />
//                             )}

//                             {/* Password Field */}
//                             <div
//                                 style={{ position: "relative", display: "inline-block", width: "100%", marginBottom: "15px" }}
//                             >
//                                 <input
//                                     type={showPassword ? "text" : "password"}
//                                     name="password"
//                                     placeholder="Create Password"
//                                     value={loginObj.password}
//                                     onChange={handleChange}
//                                     style={{
//                                         padding: "10px",
//                                         fontSize: "16px",
//                                         border: "1px solid #ccc",
//                                         borderRadius: "6px",
//                                         width: "100%",
//                                         boxSizing: "border-box",
//                                     }}
//                                 />
//                                 <span
//                                     onClick={() => setShowPassword(!showPassword)}
//                                     style={{
//                                         position: "absolute",
//                                         top: "50%",
//                                         right: "10px",
//                                         transform: "translateY(-50%)",
//                                         cursor: "pointer",
//                                         color: "#888",
//                                     }}
//                                 >
//                                     {showPassword ? <FaEyeSlash /> : <FaEye />}
//                                 </span>
//                             </div>

//                             {/* Referral Code Field */}
//                             <div style={{ width: "100%", marginBottom: "20px" }}>
//                                 <label
//                                     style={{
//                                         display: "block",
//                                         fontSize: "14px",
//                                         fontWeight: "600",
//                                         color: "#444",
//                                         marginBottom: "6px",
//                                     }}
//                                 >
//                                     🎁 Have a Referral Code?
//                                 </label>
//                                 <div style={{ position: "relative", width: "100%" }}>
//                                     <input
//                                         type="text"
//                                         name="referralCode"
//                                         placeholder="Enter your referral code "
//                                         value={loginObj.referralCodeUsed}
//                                         onChange={handleChange}
//                                         style={{
//                                             padding: "12px 40px 12px 12px",
//                                             fontSize: "16px",
//                                             border: "2px dashed #7c3aed", // dashed border highlight
//                                             borderRadius: "8px",
//                                             width: "100%",
//                                             boxSizing: "border-box",
//                                             backgroundColor: "#f9f5ff", // light purple background
//                                             fontWeight: "500",
//                                             color: "#111",
//                                         }}
//                                     />
//                                     <span
//                                         style={{
//                                             position: "absolute",
//                                             top: "50%",
//                                             right: "12px",
//                                             transform: "translateY(-50%)",
//                                             fontSize: "18px",
//                                             color: "#7c3aed",
//                                             fontWeight: "bold",
//                                         }}
//                                     >
//                                         %
//                                     </span>
//                                 </div>
//                                 <small style={{ color: "#6b7280", fontSize: "12px" }}>
//                                     Apply referral code & unlock exciting rewards!
//                                 </small>
//                             </div>

//                             <div
//                                 style={{
//                                     display: "flex",
//                                     alignItems: "center",
//                                     flexWrap: "wrap",
//                                     gap: "6px",
//                                     fontSize: "14px",
//                                     lineHeight: "20px",
//                                 }}
//                             >
//                                 <input
//                                     type="checkbox"
//                                     checked={termsAccepted}
//                                     onChange={(e) => setTermsAccepted(e.target.checked)}
//                                 />
//                                 <span>I hereby agree to the</span>
//                                 <a
//                                     href="/Termscondition"
//                                     rel="noopener noreferrer"
//                                     style={{ color: "#007bff", textDecoration: "none" }}
//                                 >
//                                     Terms & Conditions
//                                 </a>
//                                 <span>and</span>
//                                 <a
//                                     href="/privacy-policys"
//                                     target="_blank"
//                                     rel="noopener noreferrer"
//                                     style={{ color: "#007bff", textDecoration: "none" }}
//                                 >
//                                     Privacy Policy
//                                 </a>
//                                 <span>of Maamaas</span>
//                             </div>

//                             <button
//                                 type="submit"
//                                 disabled={!termsAccepted || isLoading}
//                                 style={{
//                                     backgroundColor: !termsAccepted ? "gray" : "#ee6521",
//                                     color: "white",
//                                     fontWeight: "bold",
//                                     padding: "12px",
//                                     border: "none",
//                                     borderRadius: "6px",
//                                     cursor: !termsAccepted ? "not-allowed" : "pointer",
//                                 }}
//                             >
//                                 {isLoading ? "Signing up..." : "SIGN UP"}
//                             </button>

//                             {error && (
//                                 <div style={{ color: "red", marginTop: "10px" }}>{error}</div>
//                             )}
//                         </form>

//                     </>
//                 )}

//                 {/* Switch Between Login & Signup */}
//                 {!isForgot && (
//                     <div style={{ textAlign: "center" }}>
//                         <p style={{ fontSize: "14px" }}>
//                             {isSignup
//                                 ? "Already have an account?"
//                                 : "Don't have an account?"}{" "}
//                             <span
//                                 onClick={() => {
//                                     setIsSignup(!isSignup);
//                                     setIsForgot(false);
//                                 }}
//                                 style={{
//                                     color: "#ee6521",
//                                     fontWeight: "bold",
//                                     cursor: "pointer",
//                                 }}
//                             >
//                                 {isSignup ? "Login here" : "Sign up"}
//                             </span>
//                         </p>

//                     </div>
//                 )}
//             </div>

//             {showContainer && (
//                 <>
//                     <Slide direction="down" in={true} mountOnEnter unmountOnExit>
//                         <Paper
//                             sx={{
//                                 position: "fixed",
//                                 top: "60px",
//                                 right: "10px",
//                                 width: "150px",
//                                 backgroundColor: "white",
//                                 boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
//                                 borderRadius: "10px",
//                                 zIndex: 1000,
//                                 overflow: "auto",
//                             }}
//                         >
//                             <MenuItem
//                                 onClick={handleLogout}
//                                 sx={{
//                                     display: "flex",
//                                     justifyContent: "space-between",
//                                     alignItems: "center",
//                                     padding: "10px 14px",
//                                     fontSize: "15px",
//                                     fontWeight: 500,
//                                 }}
//                             >
//                                 Logout
//                                 <LogoutIcon fontSize="small" />
//                             </MenuItem>

//                          {!loadingStatus && verificationStatus === "VERIFIED" && (
//     <MenuItem
//         onClick={handleProfile}
//         sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             padding: "10px 14px",
//             fontSize: "15px",
//             fontWeight: 500,
//         }}
//     >
//         Profile
//         <PersonIcon fontSize="small" />
//     </MenuItem>
// )}


//                         </Paper>
//                     </Slide>

//                     {/* INTERNAL CSS */}
//                     <style>{`
//     @keyframes fadeIn {
//       from { opacity: 0; transform: translateY(-4px); }
//       to { opacity: 1; transform: translateY(0); }
//     }

//     @media (max-width: 600px) {
//       .profile-icon, 
//       .profile-icon svg {
//         color: white !important;
//         border: none !important;
//         outline: none !important;
//       }
//     }
//   `}</style>
//                 </>
//             )}
//         </>
//     );
// }



import React, { useState, useEffect, useRef } from "react";
import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube, FaBars, FaTimes } from "react-icons/fa";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import logo from "../pages/modules/Component/maamaaslog.png";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Link } from 'react-router-dom';
import SliderComponent from '../pages/modules/Cloudkitchen/SliderComponent.js';
import { Paper, MenuItem, Slide, IconButton } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import PersonIcon from "@mui/icons-material/Person";
import { FaMapMarkerAlt } from "react-icons/fa";
import { FaSearch } from "react-icons/fa";

export default function ProfissionalNavbar({ showLogin, setShowLogin }) {
    const [index, setIndex] = useState(0);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [scrolled, setScrolled] = useState(false);
    const [showMobileMenu, setShowMobileMenu] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [showForgetPassword, setShowForgetPassword] = useState(false);
    const [isForgot, setIsForgot] = useState(false);
    const [loginObj, setLoginObj] = useState({
        userName: "",
        password: "",
    });
    const [showPassword, setShowPassword] = useState(false);
    const [hidePassword, setHidePassword] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const [showPasswordFields, setShowPasswordFields] = useState(false);
    const [forgotEmail, setForgotEmail] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [isSignup, setIsSignup] = useState(false);
    const [isEmailSubmitted, setIsEmailSubmitted] = useState(false);
    const [loginStepStarted, setLoginStepStarted] = useState(false);
    const [emailCheckMessage, setEmailCheckMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [cartCount, setCartCount] = useState(0);
    const [signupType, setSignupType] = useState("personal");
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [showContainer, setShowContainer] = useState(false);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [isLoginOpen, setIsLoginOpen] = useState(false);
    const GOOGLE_API_KEY = "";
    const [userLocation, setUserLocation] = useState("");

    const [savedAddresses, setSavedAddresses] = useState(() => {
        const data = localStorage.getItem("savedAddresses");
        return data ? JSON.parse(data) : [];
    });

    // Location states
    const [showLocationPopup, setShowLocationPopup] = useState(false);
    const [selectedAddress, setSelectedAddress] = useState(null);

    const [searchQuery, setSearchQuery] = useState("");
    const [isLocating, setIsLocating] = useState(false);
    const [locationError, setLocationError] = useState("");
    const [showMapPopup, setShowMapPopup] = useState(false);
    const [mapSelectedLocation, setMapSelectedLocation] = useState(null);
    const [mapAddress, setMapAddress] = useState("");
    const [addressTitle, setAddressTitle] = useState("");
    const [isMapLoading, setIsMapLoading] = useState(false);
    const [showMobileSearch, setShowMobileSearch] = useState(false);
    const mapRef = useRef(null);

    const openLoginDrawer = () => setIsLoginOpen(true);
    const closeLoginDrawer = () => setIsLoginOpen(false);

    const userId = localStorage.getItem("userId");

    const SAVED_KEY = `savedAddresses_${userId}`;
    const CURRENT_KEY = `currentLocation_${userId}`;
    const SELECTED_KEY = `selectedAddress_${userId}`;
    const [verificationStatus, setVerificationStatus] = useState(null);
    const [loadingStatus, setLoadingStatus] = useState(true);

    useEffect(() => {
        const professionalUserId = localStorage.getItem("professionalUserId");
        const token = localStorage.getItem("authToken");

        if (!professionalUserId || !token) {
            setVerificationStatus(null);
            setLoadingStatus(false);
            alert("User ID or Token missing");
            return;
        }

        const fetchVerificationStatus = async () => {
            try {
                const response = await fetch(
                    `https://backend.maamaas.com/subscription/api/user/company/verification/${professionalUserId}`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (!response.ok) {
                    setVerificationStatus(null);
                    alert("Failed to fetch verification status");
                    return;
                }

                const data = await response.json();
                setVerificationStatus(data.verificationStatus);

            } catch (error) {
                alert("Something went wrong while fetching status");
                setVerificationStatus(null);
            } finally {
                setLoadingStatus(false);
            }
        };

        fetchVerificationStatus();
    }, []);

    useEffect(() => {
        if (isSignup) {
            setIsSignup(true);
            setShowLogin(true);
        }
    }, [isSignup]);

    useEffect(() => {
        let timeoutId;
        if (showContainer) {
            timeoutId = setTimeout(() => {
                setShowContainer(false);
            }, 4000);
        }

        return () => {
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, [showContainer]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            const profileIcon = document.querySelector('[data-profile-icon]');
            const dropdown = document.querySelector('[data-profile-dropdown]');

            if (showContainer &&
                profileIcon &&
                dropdown &&
                !profileIcon.contains(event.target) &&
                !dropdown.contains(event.target)) {
                setShowContainer(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [showContainer]);

    function handleSignInClick() {
        setShowLogin(true);
    }

    const handleProfile = () => {
        setShowContainer(false);

        setTimeout(() => {
            navigate("/Profesanlprofile");
        }, 0);
    };

    const handleLogout = () => {
        localStorage.removeItem("isLoggedIn");
        localStorage.removeItem("authToken");
        localStorage.removeItem("vendorId");
        localStorage.removeItem("professionalUserId");
        localStorage.removeItem("userId");

        setIsLoggedIn(false);
        setShowContainer(false);

        navigate("/", { replace: true });
        window.location.reload();
    };

    useEffect(() => {
        const token = localStorage.getItem("userToken");
        if (token) {
            setIsLoggedIn(true);
        }
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
            if (window.innerWidth > 768) {
                setShowMobileMenu(false);
            }
        };

        const handleScroll = () => setScrolled(window.scrollY > 50);

        window.addEventListener("resize", handleResize);
        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("resize", handleResize);
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const handleChange = (e) => {
        setLoginObj({ ...loginObj, [e.target.name]: e.target.value });
    };

    const handleSignup = async (e) => {
        e.preventDefault();
        setError("");

        if (!termsAccepted) {
            setError("Please select Terms and Conditions");
            return;
        }

        if (!loginObj.userName || !loginObj.emailId || !loginObj.password) {
            setError("Please fill all required fields");
            return;
        }

        setIsLoading(true);

        const userType = signupType === "personal" ? "PERSONAL" : "PROFESSIONAL";

        const requestBody = {
            userName: loginObj.userName,
            emailId: loginObj.emailId,
            password: loginObj.password,
            referralCodeUsed: loginObj.referralCodeUsed || null,
            mobileNumber: loginObj.mobileNumber,
            companyName: loginObj.companyName || null,
            role: "ROLE_USER",
            userType: userType,
            termsAndConditions: termsAccepted,
        };

        const apiUrl =
            "https://backend.maamaas.com/subscription/api/user/registration";

        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestBody),
            });

            let resultText = await response.text();
            let result;
            try {
                result = JSON.parse(resultText);
            } catch {
                result = { message: resultText };
            }

            if (response.ok) {
                alert("Signup successful!");
                setIsSignup(false);
                setIsForgot(false);
            } else {
                setError(result.message || "Signup failed");
            }
        } catch (error) {
            setError("Something went wrong. Please try again.");
        }

        setIsLoading(false);
    };

    const handleChanges = (e) => {
        const { name, value } = e.target;
        setLoginObj((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const [isLoggedIn, setIsLoggedIn] = useState(false);
    useEffect(() => {
        const loggedIn = localStorage.getItem("isLoggedIn") === "true";
        setIsLoggedIn(loggedIn);
    }, []);

    const handleLogin = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError("");

        try {
            const url = `https://backend.maamaas.com/subscription/api/auth/login/user?identifier=${encodeURIComponent(
                loginObj.identifier
            )}&password=${encodeURIComponent(loginObj.password)}`;

            const response = await fetch(url, {
                method: "POST",
                headers: {
                    accept: "*/*",
                },
            });

            const text = await response.text();
            let data;
            try {
                data = JSON.parse(text);
            } catch {
                throw new Error("Invalid JSON response from server");
            }

            if (response.ok && data.token) {
                localStorage.setItem("authToken", data.token);
                localStorage.setItem("refreshToken", data.refreshToken);
                localStorage.setItem("userId", data.userId);
                localStorage.setItem("userType", data.userType || "");
                localStorage.setItem("professionalUserId", data.professionalUserId);
                localStorage.setItem("role", data.role);
                localStorage.setItem("isLoggedIn", "true");

                alert("Login successful!");
                setIsLoggedIn(true);
                setShowLogin(false);
                navigate("/Digitalfoodall");
                const redirectTo =
                    localStorage.getItem("redirectAfterLogin") || "/Digitalfoodall";

                localStorage.removeItem("redirectAfterLogin");

                navigate(redirectTo);
            } else {
                setError(data.message || "Invalid credentials. Please check your email or password.");
            }

        } catch (error) {
            setError("Email or Password wrong. Please try again later.");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        const checkLogin = () => {
            const loggedIn = localStorage.getItem("isLoggedIn") === "true";
            setIsLoggedIn(loggedIn);
        };

        checkLogin();

        window.addEventListener("storage", checkLogin);

        return () => {
            window.removeEventListener("storage", checkLogin);
        };
    }, []);

    const togglePopup = () => {
        setShowPopup(!showPopup);
    };

    const toggleMobileMenu = () => {
        setShowMobileMenu(!showMobileMenu);
    };

    const toggleMobileSearch = () => {
        setShowMobileSearch(!showMobileSearch);
        setShowMobileMenu(false);
    };

    const getColoredText = (text) => {
        const words = text.split(" ");
        const half = Math.ceil(words.length / 2);
        return (
            <>
                <span style={{ color: "#FFD700" }}>{words.slice(0, half).join(" ")} </span>
                <span style={{ color: "white" }}>{words.slice(half).join(" ")}</span>
            </>
        );
    };

    useEffect(() => {
        if (showMapPopup) {
            if (!document.querySelector('link[href*="leaflet"]')) {
                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.href = 'https://unpkg.com/leaflet@1.7.1/dist/leaflet.css';
                document.head.appendChild(link);
            }

            if (!window.L) {
                const script = document.createElement('script');
                script.src = 'https://unpkg.com/leaflet@1.7.1/dist/leaflet.js';
                script.onload = initializeMap;
                document.head.appendChild(script);
            } else {
                initializeMap();
            }
        }
    }, [showMapPopup]);

    const initializeMap = () => {
        if (!mapRef.current || !window.L) return;

        if (window.currentMap) {
            window.currentMap.remove();
        }

        const defaultLocation = [40.7128, -74.0060];

        const map = window.L.map(mapRef.current).setView(defaultLocation, 13);
        window.currentMap = map;

        window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '© OpenStreetMap contributors'
        }).addTo(map);

        map.on('click', (e) => {
            const clickedLocation = [e.latlng.lat, e.latlng.lng];
            setMapSelectedLocation(clickedLocation);
            updateMarker(clickedLocation, map);
            getAddressFromCoordinates(clickedLocation);
        });

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const userLocation = [position.coords.latitude, position.coords.longitude];
                    map.setView(userLocation, 15);
                    setMapSelectedLocation(userLocation);
                    updateMarker(userLocation, map);
                    getAddressFromCoordinates(userLocation);
                },
                () => {
                    setMapSelectedLocation(defaultLocation);
                    updateMarker(defaultLocation, map);
                    getAddressFromCoordinates(defaultLocation);
                }
            );
        }
    };

    const updateMarker = (location, map) => {
        if (window.currentMarker) {
            window.currentMarker.remove();
        }

        const marker = window.L.marker(location, { draggable: true }).addTo(map);
        window.currentMarker = marker;

        marker.on('dragend', (e) => {
            const draggedLocation = [e.target.getLatLng().lat, e.target.getLatLng().lng];
            setMapSelectedLocation(draggedLocation);
            getAddressFromCoordinates(draggedLocation);
        });
    };

    const getAddressFromCoordinates = async (location) => {
        setIsMapLoading(true);
        try {
            const response = await fetch(
                `https://maps.googleapis.com/maps/api/geocode/json?latlng=${location[0]},${location[1]}&key=`
            );
            const data = await response.json();

            if (data.status === "OK" && data.results.length > 0) {
                setMapAddress(data.results[0].formatted_address);
            } else {
                setMapAddress("Address not found");
            }
        } catch (error) {
            setMapAddress("Error getting address");
        } finally {
            setIsMapLoading(false);
        }
    };

    useEffect(() => {
        localStorage.setItem("savedAddresses", JSON.stringify(savedAddresses));
    }, [savedAddresses]);

    useEffect(() => {
        if (selectedAddress) {
            localStorage.setItem("selectedAddress", selectedAddress);
        }
    }, [selectedAddress]);

    useEffect(() => {
        if (!userId) return;
        localStorage.setItem(SAVED_KEY, JSON.stringify(savedAddresses));
    }, [savedAddresses, userId]);

    useEffect(() => {
        if (!userId || !selectedAddress) return;
        localStorage.setItem(SELECTED_KEY, selectedAddress);
    }, [selectedAddress, userId]);

    useEffect(() => {
        if (!userId) return;

        const saved = localStorage.getItem(SAVED_KEY);
        const current = localStorage.getItem(CURRENT_KEY);

        if (saved) setSavedAddresses(JSON.parse(saved));

        if (current) {
            const c = JSON.parse(current);
            setSelectedAddress(c.full);
            setUserLocation({ lat: c.lat, lng: c.lng });
        }
    }, [userId]);

    const handleSaveAddressFromMap = async () => {
        if (!mapSelectedLocation || !mapAddress) return;

        const newAddress = {
            title: addressTitle || "Custom Location",
            full: mapAddress,
            lat: mapSelectedLocation[0],
            lng: mapSelectedLocation[1],
        };

        setSavedAddresses(prev => [newAddress, ...prev]);
        setSelectedAddress(mapAddress);

        const token = localStorage.getItem("authToken");
        if (token && userId) {
            await fetch(
                "https://backend.maamaas.com/subscription/api/user/curret/location/update",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        userId,
                        latitude: newAddress.lat,
                        longitude: newAddress.lng,
                        address: newAddress.full,
                    }),
                }
            );
        }

        setShowMapPopup(false);
        setShowLocationPopup(false);
    };

    useEffect(() => {
        const storedCurrent = localStorage.getItem("currentLocation");
        const saved = localStorage.getItem("savedAddresses");

        if (storedCurrent) {
            const c = JSON.parse(storedCurrent);
            setSelectedAddress(c.full);
            setUserLocation({ lat: c.lat, lng: c.lng });
        }

        if (saved) {
            setSavedAddresses(JSON.parse(saved));
        }
    }, []);

    const getCurrentLocation = () => {
        if (!navigator.geolocation) {
            setLocationError("Geolocation not supported");
            return;
        }

        setIsLocating(true);
        setLocationError("");

        navigator.geolocation.getCurrentPosition(
            async (pos) => {
                const latitude = pos?.coords?.latitude;
                const longitude = pos?.coords?.longitude;

                if (latitude == null || longitude == null) {
                    setLocationError("Unable to fetch latitude / longitude");
                    setIsLocating(false);
                    return;
                }

                let fullAddress = `Lat: ${latitude}, Lng: ${longitude}`;

                try {
                    if (GOOGLE_API_KEY) {
                        const res = await fetch(
                            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${GOOGLE_API_KEY}`
                        );
                        const data = await res.json();
                        fullAddress = data?.results?.[0]?.formatted_address || fullAddress;
                    }
                } catch (err) {
                    // Silent catch
                }

                const currentLocation = {
                    title: "Current Location",
                    full: fullAddress,
                    lat: latitude,
                    lng: longitude,
                };

                setSelectedAddress(fullAddress);
                setUserLocation({ lat: latitude, lng: longitude });

                localStorage.setItem(CURRENT_KEY, JSON.stringify(currentLocation));

                setSavedAddresses((prev) => {
                    const exists = prev.some((a) => a.title === "Current Location");
                    return exists ? prev : [currentLocation, ...prev];
                });

                setIsLocating(false);
                setShowLocationPopup(false);
            },
            (error) => {
                let msg = "Location access denied";
                if (error.code === 2) msg = "Location unavailable";
                if (error.code === 3) msg = "Location request timeout";

                setLocationError(msg);
                setIsLocating(false);
            },
            {
                enableHighAccuracy: true,
                timeout: 15000,
                maximumAge: 0,
            }
        );
    };

    const handleAddressSearch = async () => {
        if (!searchQuery.trim()) return;

        try {
            const response = await fetch(
                `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(searchQuery)}&limit=5`
            );

            const data = await response.json();

            if (data && data.length > 0) {
                const result = data[0];
                const address = result.display_name;

                setSelectedAddress(address);

                setSavedAddresses(prev => [
                    {
                        title: "Searched Location",
                        full: address,
                        lat: parseFloat(result.lat),
                        lng: parseFloat(result.lon)
                    },
                    ...prev
                ]);

                setShowLocationPopup(false);
                setSearchQuery("");
            } else {
                setLocationError("No addresses found for your search.");
            }
        } catch (error) {
            setLocationError("Error searching for address. Please try again.");
        }
    };

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };

        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener("scroll", handleScroll);
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const handleEmailChange = (e) => { setEmail(e.target.value); };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage("");

        if (!email) {
            setMessage("Please enter your email.");
            setLoading(false);
            return;
        }

        try {
            const response = await axios.post(
                "https://backend.maamaas.com/subscription/api/user/forget/password",
                { identifier: email }
            );

            if (response.status === 200) {
                setMessage("Reset link sent successfully to your email.");
                setIsEmailSubmitted(true);
                if (error.response?.data?.message?.includes("already") ||
                    error.response?.data?.message?.includes("again")) {
                    setMessage("Reset link already sent. Please check your email inbox.");
                    return;
                }

            } else {
                setMessage("Something went wrong. Please try again.");
            }
        } catch (error) {
            setMessage(
                error.response?.data?.message ||
                "Error while sending reset link. Please try again."
            );
        } finally {
            setLoading(false);
        }
    };

    const styles = {
        nav: {
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            zIndex: 100,
            padding: isMobile ? "10px 16px" : "16px 32px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: scrolled ? "#ee6521" : "#ee6521",
            color: "white",
            backdropFilter: scrolled ? "blur(8px)" : "none",
            boxShadow: scrolled ? "0 2px 10px rgba(0,0,0,0.1)" : "none",
            transition: "all 0.4s ease",
            height: "65px",
        },
        logo: {
            display: "flex",
            alignItems: "center",
            fontSize: isMobile ? "20px" : "26px",
            fontWeight: "bold",
            color: "white",
            zIndex: 101,
        },
        logoText: {
            color: "white",
            fontSize: isMobile ? "16px" : "20px",
            textTransform: "uppercase",
        },
        logoTextOrange: {
            color: "orange",
            fontSize: isMobile ? "16px" : "20px",
            textTransform: "uppercase",
        },
        navRight: {
            display: isMobile ? (showMobileMenu ? "flex" : "none") : "flex",
            flexDirection: isMobile ? "row" : "row",
            alignItems: "center",
            justifyContent: "space-evenly",
            gap: isMobile ? "15px" : "20px",
            position: isMobile ? "fixed" : "relative",
            top: isMobile ? "65px" : "auto",
            left: 0,
            right: 0,
            backgroundColor: isMobile ? "#ffffffff" : "transparent",
            padding: isMobile ? "10px" : "0",
            width: isMobile ? "100%" : "auto",
            boxShadow: isMobile ? "0 5px 10px rgba(0,0,0,0.1)" : "none",
            zIndex: 100,
            borderRadius: "10px"
        },
        link: {
            textDecoration: "none",
            color: isMobile ? "#000000ff" : "white",
            fontSize: isMobile ? "17px" : "18px",
            fontWeight: "bold",
            cursor: "pointer",
            whiteSpace: "nowrap",
            padding: isMobile ? "8px 0" : "0",
            textTransform: "uppercase",
        },
        navLinks: {
            display: "flex",
            flexDirection: isMobile ? "row" : "row",
            alignItems: "center",
            gap: isMobile ? "5px" : "20px",
            marginRight: isMobile ? "0" : "20px",
        },
        iconWrapper: {
            borderRadius: "50%",
            padding: "8px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "36px",
            height: "36px",
            cursor: "pointer",
        },
        signInBtn: {
            padding: isMobile ? "8px 16px" : "10px 20px",
            backgroundColor: "orange",
            border: "none",
            borderRadius: "15px",
            color: "white",
            fontWeight: "600",
            cursor: "pointer",
            fontSize: isMobile ? "14px" : "16px",
            whiteSpace: "nowrap",
            textTransform: "uppercase",
        },
        mobileMenuButton: {
            display: isMobile ? "block" : "none",
            background: "none",
            border: "none",
            color: "white",
            fontSize: "24px",
            cursor: "pointer",
            zIndex: 102,
        },
        loginForm: {
            position: "fixed",
            top: isMobile ? "10px" : "20px",
            right: showLogin ? "0" : "-100%",
            width: "100%",
            maxWidth: isMobile ? "90%" : "400px",
            height: isMobile ? "90vh" : "70vh",
            backgroundColor: "white",
            borderRadius: "20px",
            padding: isMobile ? "20px 15px" : "40px 30px",
            boxShadow: "-5px 0 15px rgba(0, 0, 0, 0.1)",
            transition: "right 0.5s ease-in-out",
            zIndex: 999,
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            overflowY: "auto",
        },
        mobileSearchButton: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "8px",
            backgroundColor: "rgba(255, 255, 255, 0.15)",
            borderRadius: "50%",
            border: "none",
            color: "white",
            cursor: "pointer",
            transition: "all 0.3s ease",
        },
        locationPopupOverlay: {
            position: "fixed",
            top: 59,
            left: 0,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            padding: isMobile ? "10px" : "20px",
            boxSizing: "border-box",
        },
        locationPopup: {
            width: "100%",
            maxWidth: "500px",
            maxHeight: "80vh",
            backgroundColor: "white",
            borderRadius: "12px",
            padding: "20px",
            boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
            overflowY: "auto",
            position: "relative",
        },
        popupHeader: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
            paddingBottom: "15px",
            borderBottom: "1px solid #eee",
        },
        popupTitle: {
            margin: 0,
            fontSize: "20px",
            fontWeight: "600",
            color: "#333",
        },
        closePopupBtn: {
            background: "transparent",
            border: "none",
            fontSize: "20px",
            cursor: "pointer",
            color: "#666",
            padding: "5px",
        },
        searchContainer: {
            display: "flex",
            alignItems: "center",
            marginBottom: "20px",
            position: "relative",
        },
        searchIcon: {
            position: "absolute",
            left: "12px",
            fontSize: "16px",
            color: "#666",
            zIndex: 1,
        },
        popupSearchInput: {
            width: "100%",
            padding: "12px 12px 12px 40px",
            borderRadius: "8px",
            border: "1px solid #ddd",
            fontSize: "14px",
            outline: "none",
            transition: "border 0.3s ease",
        },
        optionBox: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "15px",
            backgroundColor: "#f8f9fa",
            borderRadius: "8px",
            marginBottom: "15px",
            cursor: "pointer",
            transition: "all 0.3s ease",
            border: "1px solid #e9ecef",
        },
        optionContent: {
            display: "flex",
            alignItems: "center",
            gap: "12px",
        },
        optionTitle: {
            margin: 0,
            fontSize: "16px",
            fontWeight: "600",
            color: "#333",
        },
        optionDesc: {
            margin: "4px 0 0 0",
            fontSize: "13px",
            color: "#666",
        },
        enableBtn: {
            padding: "8px 16px",
            backgroundColor: "#9d36caff",
            color: "white",
            border: "none",
            borderRadius: "6px",
            fontSize: "13px",
            fontWeight: "500",
            cursor: "pointer",
            transition: "background 0.3s ease",
            display: "flex",
            alignItems: "center",
            gap: "6px",
        },
        addAddressBox: {
            display: "flex",
            alignItems: "center",
            gap: "12px",
            padding: "15px",
            backgroundColor: "#f0f8ff",
            borderRadius: "8px",
            marginBottom: "20px",
            cursor: "pointer",
            transition: "all 0.3s ease",
            border: "1px dashed #a54dd4ff",
        },
        plusIcon: {
            fontSize: "18px",
            color: "#a551d9ff",
            fontWeight: "bold",
        },
        addAddressText: {
            fontSize: "16px",
            fontWeight: "500",
            color: "#983fc1ff",
        },
        errorMessage: {
            padding: "10px 15px",
            backgroundColor: "#ffe6e6",
            color: "#d63031",
            borderRadius: "6px",
            marginBottom: "15px",
            fontSize: "14px",
        },
        savedHeading: {
            fontSize: "16px",
            fontWeight: "600",
            color: "#333",
            marginBottom: "12px",
        },
        savedBox: {
            display: "flex",
            alignItems: "flex-start",
            gap: "12px",
            padding: "15px",
            backgroundColor: "#fff",
            borderRadius: "8px",
            marginBottom: "10px",
            cursor: "pointer",
            transition: "all 0.3s ease",
            border: "1px solid #eee",
        },
        savedLeft: {
            display: "flex",
            alignItems: "center",
            gap: "8px",
        },
        pinIcon: {
            color: "#d63031",
            fontSize: "16px",
        },
        savedTitle: {
            margin: 0,
            fontSize: "15px",
            fontWeight: "600",
            color: "#333",
        },
        savedAddressText: {
            margin: "4px 0 0 0",
            fontSize: "13px",
            color: "#666",
            lineHeight: "1.4",
        },
        loadingSpinner: {
            display: "inline-block",
            width: "12px",
            height: "12px",
            border: "2px solid transparent",
            borderTop: "2px solid currentColor",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
        },
        mobileSearchContainer: {
            display: isMobile && showMobileSearch ? "flex" : "none",
            position: "fixed",
            top: "65px",
            left: 0,
            right: 0,
            backgroundColor: "white",
            padding: "15px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
            zIndex: 99,
            alignItems: "center",
            gap: "10px",
        },
        mobileSearchInput: {
            flex: 1,
            padding: "12px 15px",
            borderRadius: "25px",
            border: "1px solid #ddd",
            outline: "none",
            fontSize: "14px",
            backgroundColor: "#f8f9fa",
        },
        mobileSearchClose: {
            background: "transparent",
            border: "none",
            fontSize: "20px",
            cursor: "pointer",
            color: "#666",
        },
    };

    return (
        <>
            {/* Navbar */}
            <nav style={styles.nav}>
                <div style={styles.logo}>
                    <Link
                        to="/"
                        style={{
                            ...styles.logo,
                            textDecoration: "none",
                        }}
                    >
                        <div
                            style={{
                                fontSize: window.innerWidth <= 600 ? "20px" : "32px",
                                fontWeight: "bold",
                                fontFamily: "'Poppins', sans-serif",
                                display: "inline-block",
                                margin: 0,
                            }}
                        >
                            <span style={{ color: "white" }}>MAA</span>
                            <span style={{ color: "white" }}>MAAS</span>
                        </div>
                    </Link>
                </div>

                {isMobile && (
                    <div
                        style={{
                            border: "2px solid white",
                            padding: "6px 16px",
                            display: "flex",
                            borderRadius: "25px",
                            alignItems: "center",
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                            color: "white",
                            backgroundColor: "transparent",
                        }}
                        onClick={() => setShowContainer(!showContainer)}
                    >
                        <AccountCircleIcon sx={{ fontSize: "22px", color: "white" }} />
                    </div>
                )}

                <div style={styles.navRight}>
                    <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                        {isLoggedIn ? (
                            <>
                                <div
                                    style={{
                                        border: isMobile ? "2px solid black" : "2px solid white",
                                        padding: "6px 16px",
                                        borderRadius: "25px",
                                        display: "flex",
                                        alignItems: "center",
                                        cursor: "pointer",
                                        transition: "all 0.3s ease",
                                        color: isMobile ? "black" : "white",
                                        backgroundColor: "transparent",
                                    }}
                                    onClick={() => setShowContainer(!showContainer)}
                                    onMouseEnter={(e) => {
                                        if (!isMobile) {
                                            e.currentTarget.style.backgroundColor = "white";
                                            e.currentTarget.style.color = "#ff6600";
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!isMobile) {
                                            e.currentTarget.style.backgroundColor = "transparent";
                                            e.currentTarget.style.color = "white";
                                        }
                                    }}
                                >
                                    <AccountCircleIcon
                                        sx={{ fontSize: "22px", color: isMobile ? "black" : "white" }}
                                    />
                                </div>

                            </>
                        ) : (
                            <SliderComponent setShowLogin={setShowLogin} />
                        )}
                    </div>
                </div>
            </nav>

            {/* Login Form Popup */}
            <div style={styles.loginForm}>
                <button
                    style={{
                        position: "absolute",
                        top: "15px",
                        right: "20px",
                        fontSize: "28px",
                        background: "none",
                        border: "none",
                        color: "#333",
                        cursor: "pointer",
                    }}
                    onClick={() => {
                        setShowLogin(false);
                        setIsForgot(false);
                        setIsSignup(false);
                    }}
                >
                    &times;
                </button>

                <p
                    style={{
                        marginBottom: 0,
                        fontFamily: "revert",
                        fontSize: isMobile ? "18px" : "22px",
                        color: "#6f21b4ff",
                        fontWeight: "bold",
                    }}
                >
                    WELCOME TO MAAMAA'S
                </p>

                {!isSignup && !isForgot && (
                    <>
                        <form
                            onSubmit={handleLogin}
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "10px",
                            }}
                        >
                            <input
                                type="text"
                                placeholder="User ID"
                                name="identifier"
                                value={loginObj.identifier}
                                onChange={handleChanges}
                                style={{
                                    padding: "10px",
                                    fontSize: "16px",
                                    border: "1px solid #ccc",
                                    borderRadius: "6px",
                                }}
                            />

                            <div style={{ position: "relative", display: "inline-block", width: "100%" }}>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Password"
                                    name="password"
                                    value={loginObj.password}
                                    onChange={handleChanges}
                                    style={{
                                        padding: "10px",
                                        paddingRight: "40px",
                                        fontSize: "16px",
                                        border: "1px solid #ccc",
                                        borderRadius: "6px",
                                        width: "100%",
                                        boxSizing: "border-box"
                                    }}
                                />
                                <span
                                    onClick={() => setShowPassword(!showPassword)}
                                    style={{
                                        position: "absolute",
                                        top: "50%",
                                        right: "10px",
                                        transform: "translateY(-50%)",
                                        cursor: "pointer",
                                        color: "#888"
                                    }}
                                >
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </span>
                            </div>

                            <div style={{ textAlign: "right" }}>
                                <span
                                    onClick={() => setIsForgot(true)}
                                    style={{
                                        color: "#007bff",
                                        fontSize: "14px",
                                        textDecoration: "none",
                                        cursor: "pointer",
                                    }}
                                >
                                    Forget Password?
                                </span>
                            </div>
                            {error && (
                                <p style={{ color: "red", marginTop: "10px" }}>{error}</p>
                            )}
                            <button
                                type="submit"
                                style={{
                                    backgroundColor: "#ee6521",
                                    color: "white",
                                    fontWeight: "bold",
                                    padding: "12px",
                                    border: "none",
                                    borderRadius: "6px",
                                    cursor: "pointer",
                                }}
                                disabled={isLoading}
                            >
                                {isLoading ? "Logging in..." : "LOGIN"}
                            </button>
                        </form>
                    </>
                )}

                {isForgot && !isEmailSubmitted && (
                    <form onSubmit={handleSubmit}>
                        <div>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                placeholder="Enter your email"
                                value={email}
                                onChange={handleEmailChange}
                                required
                                style={{
                                    padding: "10px",
                                    fontSize: "16px",
                                    border: "1px solid #ccc",
                                    borderRadius: "6px",
                                    marginBottom: "10px",
                                    width: "100%",
                                }}
                            />
                        </div>

                        <button
                            type="submit"
                            style={{
                                backgroundColor: "#ee6521",
                                color: "white",
                                fontWeight: "bold",
                                padding: "12px",
                                border: "none",
                                borderRadius: "6px",
                                cursor: "pointer",
                                width: "100%",
                            }}
                            disabled={loading}
                        >
                            {loading ? "Sending..." : "Submit"}
                        </button>

                        <div style={{ marginTop: "10px", textAlign: "center" }}>
                            <span
                                onClick={() => setIsForgot(false)}
                                style={{
                                    color: "#007bff",
                                    fontSize: "14px",
                                    cursor: "pointer",
                                }}
                            >
                                Back to Login
                            </span>
                        </div>

                        {message && (
                            <p style={{ marginTop: "12px", color: "red", textAlign: "center" }}>
                                {message}
                            </p>
                        )}
                    </form>
                )}

                {message && (
                    <div
                        style={{
                            marginTop: "15px",
                            padding: "10px",
                            borderRadius: "6px",
                            textAlign: "center",
                            color: message.includes("successfully") ? "green" : "red",
                            fontWeight: "bold",
                        }}
                    >
                        {message}
                    </div>
                )}

                {isSignup && (
                    <>
                        <div
                            style={{
                                display: "flex",
                                gap: "20px",
                                justifyContent: "center",
                                marginBottom: "10px",
                            }}
                        >
                            <label>
                                <input
                                    type="radio"
                                    name="signupType"
                                    value="personal"
                                    checked={signupType === "personal"}
                                    onChange={() => setSignupType("personal")}
                                />{" "}
                                Personal
                            </label>
                            <label>
                                <input
                                    type="radio"
                                    name="signupType"
                                    value="professional"
                                    checked={signupType === "professional"}
                                    onChange={() => setSignupType("professional")}
                                />{" "}
                                Professional
                            </label>
                        </div>

                        <form
                            onSubmit={handleSignup}
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "10px",
                            }}
                        >
                            <input
                                type="text"
                                name="userName"
                                placeholder="Name"
                                value={loginObj.userName}
                                onChange={handleChange}
                                style={{
                                    padding: "10px",
                                    fontSize: "16px",
                                    border: "1px solid #ccc",
                                    borderRadius: "6px",
                                }}
                            />
                            <input
                                type="email"
                                name="emailId"
                                placeholder="Email"
                                value={loginObj.emailId}
                                onChange={handleChange}
                                style={{
                                    padding: "10px",
                                    fontSize: "16px",
                                    border: "1px solid #ccc",
                                    borderRadius: "6px",
                                }}
                            />
                            <input
                                type="text"
                                name="mobileNumber"
                                placeholder="Phone Number"
                                value={loginObj.mobileNumber}
                                onChange={handleChange}
                                style={{
                                    padding: "10px",
                                    fontSize: "16px",
                                    border: "1px solid #ccc",
                                    borderRadius: "6px",
                                }}
                            />

                            {signupType === "professional" && (
                                <input
                                    type="text"
                                    name="companyName"
                                    placeholder="Company Name"
                                    value={loginObj.companyName}
                                    onChange={handleChange}
                                    style={{
                                        padding: "10px",
                                        fontSize: "16px",
                                        border: "1px solid #ccc",
                                        borderRadius: "6px",
                                    }}
                                />
                            )}

                            <div
                                style={{ position: "relative", display: "inline-block", width: "100%", marginBottom: "15px" }}
                            >
                                <input
                                    type={showPassword ? "text" : "password"}
                                    name="password"
                                    placeholder="Create Password"
                                    value={loginObj.password}
                                    onChange={handleChange}
                                    style={{
                                        padding: "10px",
                                        fontSize: "16px",
                                        border: "1px solid #ccc",
                                        borderRadius: "6px",
                                        width: "100%",
                                        boxSizing: "border-box",
                                    }}
                                />
                                <span
                                    onClick={() => setShowPassword(!showPassword)}
                                    style={{
                                        position: "absolute",
                                        top: "50%",
                                        right: "10px",
                                        transform: "translateY(-50%)",
                                        cursor: "pointer",
                                        color: "#888",
                                    }}
                                >
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </span>
                            </div>

                            <div style={{ width: "100%", marginBottom: "20px" }}>
                                <label
                                    style={{
                                        display: "block",
                                        fontSize: "14px",
                                        fontWeight: "600",
                                        color: "#444",
                                        marginBottom: "6px",
                                    }}
                                >
                                    🎁 Have a Referral Code?
                                </label>
                                <div style={{ position: "relative", width: "100%" }}>
                                    <input
                                        type="text"
                                        name="referralCode"
                                        placeholder="Enter your referral code "
                                        value={loginObj.referralCodeUsed}
                                        onChange={handleChange}
                                        style={{
                                            padding: "12px 40px 12px 12px",
                                            fontSize: "16px",
                                            border: "2px dashed #7c3aed",
                                            borderRadius: "8px",
                                            width: "100%",
                                            boxSizing: "border-box",
                                            backgroundColor: "#f9f5ff",
                                            fontWeight: "500",
                                            color: "#111",
                                        }}
                                    />
                                    <span
                                        style={{
                                            position: "absolute",
                                            top: "50%",
                                            right: "12px",
                                            transform: "translateY(-50%)",
                                            fontSize: "18px",
                                            color: "#7c3aed",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        %
                                    </span>
                                </div>
                                <small style={{ color: "#6b7280", fontSize: "12px" }}>
                                    Apply referral code & unlock exciting rewards!
                                </small>
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    flexWrap: "wrap",
                                    gap: "6px",
                                    fontSize: "14px",
                                    lineHeight: "20px",
                                }}
                            >
                                <input
                                    type="checkbox"
                                    checked={termsAccepted}
                                    onChange={(e) => setTermsAccepted(e.target.checked)}
                                />
                                <span>I hereby agree to the</span>
                                <a
                                    href="/Termscondition"
                                    rel="noopener noreferrer"
                                    style={{ color: "#007bff", textDecoration: "none" }}
                                >
                                    Terms & Conditions
                                </a>
                                <span>and</span>
                                <a
                                    href="/privacy-policys"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: "#007bff", textDecoration: "none" }}
                                >
                                    Privacy Policy
                                </a>
                                <span>of Maamaas</span>
                            </div>

                            <button
                                type="submit"
                                disabled={!termsAccepted || isLoading}
                                style={{
                                    backgroundColor: !termsAccepted ? "gray" : "#ee6521",
                                    color: "white",
                                    fontWeight: "bold",
                                    padding: "12px",
                                    border: "none",
                                    borderRadius: "6px",
                                    cursor: !termsAccepted ? "not-allowed" : "pointer",
                                }}
                            >
                                {isLoading ? "Signing up..." : "SIGN UP"}
                            </button>

                            {error && (
                                <div style={{ color: "red", marginTop: "10px" }}>{error}</div>
                            )}
                        </form>

                    </>
                )}

                {!isForgot && (
                    <div style={{ textAlign: "center" }}>
                        <p style={{ fontSize: "14px" }}>
                            {isSignup
                                ? "Already have an account?"
                                : "Don't have an account?"}{" "}
                            <span
                                onClick={() => {
                                    setIsSignup(!isSignup);
                                    setIsForgot(false);
                                }}
                                style={{
                                    color: "#ee6521",
                                    fontWeight: "bold",
                                    cursor: "pointer",
                                }}
                            >
                                {isSignup ? "Login here" : "Sign up"}
                            </span>
                        </p>

                    </div>
                )}
            </div>

            {showContainer && (
                <>
                    <Slide direction="down" in={true} mountOnEnter unmountOnExit>
                        <Paper
                            sx={{
                                position: "fixed",
                                top: "60px",
                                right: "10px",
                                width: "150px",
                                backgroundColor: "white",
                                boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
                                borderRadius: "10px",
                                zIndex: 1000,
                                overflow: "auto",
                            }}
                        >
                            <MenuItem
                                onClick={handleLogout}
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    padding: "10px 14px",
                                    fontSize: "15px",
                                    fontWeight: 500,
                                }}
                            >
                                Logout
                                <LogoutIcon fontSize="small" />
                            </MenuItem>

                            {!loadingStatus && verificationStatus === "VERIFIED" && (
                                <MenuItem
                                    onClick={handleProfile}
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        padding: "10px 14px",
                                        fontSize: "15px",
                                        fontWeight: 500,
                                    }}
                                >
                                    Profile
                                    <PersonIcon fontSize="small" />
                                </MenuItem>
                            )}

                        </Paper>
                    </Slide>

                    <style>{`
    @keyframes fadeIn {
      from { opacity: 0; transform: translateY(-4px); }
      to { opacity: 1; transform: translateY(0); }
    }

    @media (max-width: 600px) {
      .profile-icon, 
      .profile-icon svg {
        color: white !important;
        border: none !important;
        outline: none !important;
      }
    }
  `}</style>
                </>
            )}
        </>
    );
}